import { FormType } from '../../../../form-types';
import { TRTEnhancedQuestionFieldAnswers } from './questions';

const trtEnhanced: FormType<TRTEnhancedQuestionFieldAnswers> = {
  name: 'Testosterone Replacement Therapy Consultation',
  questions: [
    {
      key: 'trtEnhanced_sexAssignedAtBirth',
      next: {
        condition: { 'trtEnhanced_sexAssignedAtBirth.male': true },
        key: 'trtEnhanced_genderIdentity',
        els: 'trtEnhanced_ineligible'
      }
    },
    {
      key: 'trtEnhanced_genderIdentity',
      next: {
        switch: [
          {
            condition: { 'trtEnhanced_genderIdentity.man': true },
            key: 'trtEnhanced_fertilityPlan'
          },
          {
            condition: { 'trtEnhanced_genderIdentity.non_binary': true },
            key: 'trtEnhanced_fertilityPlan'
          }
        ],
        els: 'trtEnhanced_ineligible'
      }
    },
    {
      key: 'trtEnhanced_fertilityPlan',
      next: {
        condition: {
          'trtEnhanced_fertilityPlan.planning_children_cancel': true
        },
        key: 'trtEnhanced_ineligible',
        els: 'trtEnhanced_disqualifyingConditions'
      }
    },
    {
      key: 'trtEnhanced_disqualifyingConditions',
      next: {
        condition: { 'trtEnhanced_disqualifyingConditions.none': true },
        key: 'trtEnhanced_ltrsAgeRange',
        els: 'trtEnhanced_ineligible'
      }
    },
    'trtEnhanced_ltrsAgeRange',
    'trtEnhanced_weightHeightBmi',
    'trtEnhanced_ltrsAbdominalWeight',
    'trtEnhanced_ltrsType2Diabetes',
    'trtEnhanced_ltrsPrediabetes',
    'trtEnhanced_ltrsHighCholesterol',
    'trtEnhanced_ltrsMetabolicSyndrome',
    {
      key: 'trtEnhanced_ltrsSleepApneaDiagnosis',
      next: {
        condition: { 'trtEnhanced_ltrsSleepApneaDiagnosis.yes_3': true },
        key: 'trtEnhanced_sleepApneaConsent',
        els: 'trtEnhanced_ltrsSleepBreathingSymptoms'
      }
    },
    {
      key: 'trtEnhanced_sleepApneaConsent',
      next: {
        condition: { 'trtEnhanced_sleepApneaConsent.non_consent': true },
        key: 'trtEnhanced_didNotConsent',
        els: 'trtEnhanced_ltrsSleepBreathingSymptoms'
      }
    },
    'trtEnhanced_ltrsSleepBreathingSymptoms',
    'trtEnhanced_ltrsSleepHours',
    'trtEnhanced_ltrsSleepQuality',
    'trtEnhanced_ltrsShiftWork',
    'trtEnhanced_ltrsExerciseFrequency',
    'trtEnhanced_ltrsDietQuality',
    'trtEnhanced_ltrsChronicStress',
    'trtEnhanced_qadamLibido',
    'trtEnhanced_qadamEnergy',
    'trtEnhanced_qadamStrengthEndurance',
    'trtEnhanced_qadamEnjoymentOfLife',
    'trtEnhanced_qadamMood',
    'trtEnhanced_qadamErections',
    'trtEnhanced_qadamWorkPerformance',
    'trtEnhanced_qadamSleepAfterDinner',
    'trtEnhanced_qadamSportsPerformance',
    'trtEnhanced_qadamHeightLost',
    {
      key: 'trtEnhanced_diagnosisStatus',
      next: {
        condition: { 'trtEnhanced_diagnosisStatus.new_patient': true },
        key: 'trtEnhanced_newPatientSymptomDuration',
        els: 'trtEnhanced_continuationDiagnosisDuration'
      }
    },
    'trtEnhanced_newPatientSymptomDuration',
    'trtEnhanced_newPatientLifestyleChanges3MonthsNoImprovement',
    {
      key: 'trtEnhanced_newPatientNormalLabPreference',
      next: {
        switch: [
          {
            condition: {
              'trtEnhanced_newPatientNormalLabPreference.consider_if_normal':
                true
            },
            key: 'trtEnhanced_continuationHasLabResults'
          },
          {
            condition: {
              'trtEnhanced_newPatientNormalLabPreference.only_if_low': true
            },
            key: 'trtEnhanced_continuationHasLabResults'
          }
        ],
        els: 'trtEnhanced_ineligible'
      }
    },
    'trtEnhanced_continuationDiagnosisDuration',
    'trtEnhanced_continuationCurrentMedicationDose',
    'trtEnhanced_continuationLastDoseDate',
    'trtEnhanced_continuationMedicationDuration',
    {
      key: 'trtEnhanced_continuationResponseHappy',
      next: {
        condition: { 'trtEnhanced_continuationResponseHappy.no': true },
        key: 'trtEnhanced_continuationResponseDetails',
        els: 'trtEnhanced_continuationSideEffects'
      }
    },
    'trtEnhanced_continuationResponseDetails',
    {
      key: 'trtEnhanced_continuationSideEffects',
      next: {
        condition: { 'trtEnhanced_continuationSideEffects.other': true },
        key: 'trtEnhanced_continuationOtherSideEffects',
        els: 'trtEnhanced_continuationPastComplications'
      }
    },
    'trtEnhanced_continuationOtherSideEffects',
    {
      key: 'trtEnhanced_continuationPastComplications',
      next: {
        condition: { 'trtEnhanced_continuationPastComplications.yes': true },
        key: 'trtEnhanced_continuationPastComplicationsDetails',
        els: 'trtEnhanced_continuationAdjustmentPreference'
      }
    },
    'trtEnhanced_continuationPastComplicationsDetails',
    'trtEnhanced_continuationAdjustmentPreference',
    {
      key: 'trtEnhanced_continuationHasLabResults',
      next: {
        condition: { 'trtEnhanced_continuationHasLabResults.yes': true },
        key: 'trtEnhanced_continuationInitialLabsUpload',
        els: 'trtEnhanced_questionsForDoctor'
      }
    },
    'trtEnhanced_continuationInitialLabsUpload',
    'trtEnhanced_questionsForDoctor',
    {
      key: 'trtEnhanced_treatmentConsent',
      next: {
        condition: { 'trtEnhanced_treatmentConsent.non_consent': true },
        key: 'trtEnhanced_didNotConsent',
        els: 'trtEnhanced_complete'
      }
    },
    'trtEnhanced_complete',
    'trtEnhanced_ineligible',
    'trtEnhanced_didNotConsent'
  ]
};

export default trtEnhanced;
